"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BUTTON_DISABLED = exports.BUTTON_CONTENT = exports.BUTTON_CENTER = exports.BUTTON = exports.BUTTON_CONTAINER_DISABLED = exports.BUTTON_CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    BUTTON_CONTAINER = (0, _cxs["default"])({
  cursor: "pointer",
  display: "flex",
  alignItems: "center"
});

exports.BUTTON_CONTAINER = BUTTON_CONTAINER;
var BUTTON_CONTAINER_DISABLED = (0, _cxs["default"])({
  cursor: "default"
});
exports.BUTTON_CONTAINER_DISABLED = BUTTON_CONTAINER_DISABLED;
var BUTTON = (0, _cxs["default"])({
  border: "1px solid ".concat(_vars.COLOURS.grey.mischka.michael),
  borderRadius: "50%",
  width: "20px",
  height: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "20px",
  minHeight: "20px",
  position: "relative",
  zIndex: 0
});
exports.BUTTON = BUTTON;
var BUTTON_CENTER = (0, _cxs["default"])({
  background: _vars.COLOURS.mono.black,
  borderRadius: "50%",
  width: "16px",
  height: "16px",
  position: "relative",
  zIndex: 1
});
exports.BUTTON_CENTER = BUTTON_CENTER;
var BUTTON_CONTENT = (0, _cxs["default"])({
  marginLeft: "15px",
  fontSize: "12px"
});
exports.BUTTON_CONTENT = BUTTON_CONTENT;
var BUTTON_DISABLED = (0, _cxs["default"])({
  background: "#f2f2f2",
  cursor: "default"
});
exports.BUTTON_DISABLED = BUTTON_DISABLED;